/// <reference path="../../../typings/references.d.ts" />

module PartnershipsModule {

    class AdminSemesterLayoutController {

        constructor() {
        }
    }

    angular
        .module('app')
        .controller('AdminSemesterLayoutController', AdminSemesterLayoutController)

}